<div class="flex min-w-0 items-center break-words">
    <rwidget-route-short-name
        [label]="routeNumberLabel"
        [color]="routeNumberColor"
        [textColor]="routeNumberTextColor"
        [shape]="routeNumberShape"></rwidget-route-short-name>
    <div class="flex-align-center ml-4 flex flex-col items-start justify-center">
        <div class="flex w-full flex-row items-center">
            <div class="flex-grow">
                <p
                    class="vl-app-light:text-black text-left text-base leading-5 dark:text-contrast-yellow"
                    [ngClass]="{
                        'text-danger line-through': env.EXPLORE?.SHOW_CANCELLED_STATUS && cancelled
                    }">
                    {{ name }}
                </p>
                <p
                    class="mt-1 text-xs leading-4 tracking-wide text-grey-zambezy dark:text-contrast-yellow"
                    *ngIf="agency?.name && env.EXPLORE?.SHOW_ROUTE_GROUP_AGENCY">
                    {{ agency.name }}
                </p>
            </div>
        </div>
        <span
            class="text-xm text-black dark:text-contrast-yellow"
            *ngIf="pickupType === PickupType.NO_PICKUP && this.env.SHOW_PICK_UP_DROP_OFF_INFO"
            >{{ 'DROP_OFF_ONLY' | translate }}</span
        >
        <span
            class="text-xm text-black dark:text-contrast-yellow"
            *ngIf="dropOffType === DropOffType.NO_DROP_OFF && this.env.SHOW_PICK_UP_DROP_OFF_INFO"
            >{{ 'ALIGHTING_ONLY' | translate }}</span
        >
        <div
            class="inline-flex dark:text-contrast-yellow"
            *ngIf="env.EXPLORE?.ROUTE_DETAIL_STATUS_ENABLED"
            [attr.aria-label]="
                ('LIVE' | translate) +
                (isOnTime === null ? '. ' + ('ON_TIME' | translate) : '') +
                (isOnTime !== null ? '. ' + ('ALERT' | translate) + '. ' + (isOnTime ?? '' | translate) : '')
            "
            role="text">
            <div
                class="orb-app-light:text-grey-dark var-app-light:text-grey-dark mr-2 flex text-xs font-medium"
                *ngIf="isLive"
                aria-hidden="true">
                <ion-icon
                    class="realtime-icon mr-1 text-base dark:text-contrast-yellow"
                    src="{{ assetsPath$ | async }}/img/journey-planner/live.svg"></ion-icon>
                {{ 'LIVE' | translate }}
            </div>
            <div
                class="orb-app-light:text-grey-dark var-app-light:text-grey-dark mr-2 flex text-xs font-medium dark:text-contrast-yellow"
                *ngIf="isOnTime === null && isLive"
                aria-hidden="true">
                <ion-icon class="mr-1 text-base" src="{{ assetsPath$ | async }}/img/explore/icon-tick.svg"></ion-icon>
                {{ 'ON_TIME' | translate }}
            </div>
            <div
                class="orb-app-light:text-grey-dark mr-2 flex text-xs font-medium"
                *ngIf="isOnTime !== null && isLive"
                aria-hidden="true">
                <ion-icon
                    class="var-app-light:text-yellow-secondary orb-app-light:text-yellow-secondary mr-1 text-base"
                    src="{{ assetsPath$ | async }}/img/explore/alert-label.svg"></ion-icon>
                {{ isOnTime ?? '' | translate }}
            </div>
            <div class="flex h-4" *ngIf="operatorCode">
                <img
                    class="h-4 object-contain"
                    [src]="operatorLogosBaseUrl + operatorCode + '.svg'"
                    [hidden]="!operatorLogoFileExists"
                    (error)="operatorLogoFileExists = false"
                    title="{{ operatorName }}"
                    alt="{{ operatorCode }} {{ operatorName }} logo" />
            </div>
        </div>
    </div>
</div>
